// extracted by mini-css-extract-plugin
export default {"container":"OF-z","disabled":"PF-z","bgBlack":"QF-z","content":"RF-z","countdown":"SF-z","topCaption":"TF-z","topHeading":"UF-z","heading":"VF-z","copy":"WF-z"};